module.exports = __webpack_public_path__ + "img/logo1.27836b5f.png";